<template>
  <div id="xls-table-wrapp"
       v-html="excelDataHtml">
  </div>
</template>

<script>
  import XLSX from 'xlsx';
  import { ApiFiscalDocs } from '@/services/api';

  export default {
    name: 'ViewXlsx',

    props: {
      id: {
        default: () => {
          return null;
        },
        type: String
      }
    },

    data() {
      return {
        excelDataHtml: null
      };
    },
    created() {
      this.getXls();
    },
    methods: {

      async getXls() {
        const data = await ApiFiscalDocs.ZReport.getXls(this.id);

        const fileReader = new window.FileReader();
        fileReader.readAsArrayBuffer(data);
        fileReader.onloadend = async () => {

          const workbook = await XLSX.read(fileReader.result, {
            type: 'array',
            raw: true
          });

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          this.excelDataHtml = await XLSX.utils.sheet_to_html(worksheet, {
            editable: false,
            id: 'xls-table',
            header: '',
            footer: '',
            raw: true
          });
        };
      },

      downloadXls() {
        ApiFiscalDocs.ZReport.downLoadXls(this.id);
      }
    }
  };
</script>

<style lang="stylus">
#xls-table-wrapp {
  overflow auto
  background: #f6f6f6

  table {
    width: 100%

    tr:nth-child(even) {
      background-color: #fff;
    }

    tr:nth-child(odd) {
      background-color: #ececec;
    }

    td {
      border: 1px solid #ccc !important;
      text-align center
      vertical-align middle
      padding 3px 3px

      font-size 14px
    }
  }
}


.darkmode {
  #xls-table-wrapp {
    background: c-dark-bg

    table {
      tr:nth-child(even) {
        background-color: c-dark-bg-light;
      }

      tr:nth-child(odd) {
        background-color: c-dark-bg;
      }

      td {
        border: 1px solid c-border-dark !important;
      }
    }
  }
}

</style>
